import theme from '~lib/styles/Theme';
import type { IconProps } from '~types/icon';

const ExclamationMark = ({ width = 60, color, ...props }: IconProps) => {
  return (
    <svg
      width={width}
      height={width}
      viewBox='0 0 15 15'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}>
      <path
        d='M6.75 11.25H8.25V6.75H6.75V11.25ZM7.5 0C3.36 0 0 3.36 0 7.5C0 11.64 3.36 15 7.5 15C11.64 15 15 11.64 15 7.5C15 3.36 11.64 0 7.5 0ZM7.5 13.5C4.1925 13.5 1.5 10.8075 1.5 7.5C1.5 4.1925 4.1925 1.5 7.5 1.5C10.8075 1.5 13.5 4.1925 13.5 7.5C13.5 10.8075 10.8075 13.5 7.5 13.5ZM6.75 5.25H8.25V3.75H6.75V5.25Z'
        fill={color || theme.colors.yellow500}
      />
    </svg>
  );
};

export default ExclamationMark;
